import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import type { ApiResponse } from "@/shared/api/types";
import type { Clinic } from "@fysaro/domain";

// Definimos la interfaz de lo que limpia el backend para el público
export interface PublicClinicData {
  id: string;
  name: string;
  phone: string | null;
  formattedAddress: string | null;
  services: Array<{
    id: string;
    name: string;
    description: string | null;
    price: number;
    icon: string | null;
    color: string | null;
  }>;
}

export const getPublicClinic = async (slug: string): Promise<Clinic> => {
  // Atacamos a la sección de rutas públicas del backend
  const response = await api.get<ApiResponse<Clinic>>(
    `/clinics/public/clinics/${slug}`
  );
  return unwrap(response.data);
};